import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useApp } from '../context/AppContext';

const FloatingWhatsApp = () => {
  const { settings, t } = useApp();
  const number = (settings?.whatsapp || '').replace(/[^0-9]/g, '');
  if (!number) return null;
  const href = `https://wa.me/${number}?text=${encodeURIComponent('Hello GOBRA Capital, I would like to know more about your properties.')}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('whatsapp_us')}
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-5 right-5 z-[60] flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_-6px_rgba(37,211,102,0.7)] hover:bg-[#1ebe57] hover:scale-105 transition-transform duration-200"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping" style={{ animationDuration: '2.5s' }} />
      <MessageCircle className="relative h-7 w-7" />
    </a>
  );
};

export default FloatingWhatsApp;
